import constants from '@constants/index';
import { get } from 'lodash';

export const getStyle = (path: string, tenant = false) => {
  const STYLE = tenant
    ? constants.STYLES[constants.TENANT as keyof typeof constants.STYLES]
    : constants.STYLES.COMMON;
  return get(STYLE, path);
};

export const getAsset = (type: string, path: string) => {
  if (type === 'image') {
    return require(`../assets/images/${path}`);
  }

  return path;
};

export const getResource = (path: string) => {
  return get(constants.RESOURCE[constants.TENANT as keyof typeof constants.RESOURCE], path);
};
